/**
 * Created by jonas on 2021-02-02.
 */
import {StateMatrix, StateMatrixCoordinate} from "../utils/StateMatrix";
import {NineToFiveSymbolStates} from "../reels/symbols/NineToFiveSymbol";

export function isNineToFiveGameData(value:any):value is NineToFiveGameData {
    return value.betWayWins !== undefined;
}

export interface SymbolValues {
    [symbolName:string]:{
        3:number, 4:number, 5:number, 6:number, 7: number, 8: number, 9:number
    }
}

export interface NineToFiveData {
    reels:string[][];
    mode:string;
    nextMode:string;
    accumulatedRoundWin:number;
    freespinsLeft:number;
    wasFeatureBuy:boolean;
    boostedBet:boolean;
    symbolSizes:number[][];
    brokeTheBank:boolean;
    fsMultiplier:number;
    sfsNextMultiplier:number;
    xWaysSymbol:string;
    xNudgeMultipliers:number[];
}

export interface NineToFiveInitData extends NineToFiveData {
    nextPlayerInteraction:any;
    symbolValues:SymbolValues;
    featureBuyTimesBetValue:any;
    isRestoreState:boolean
    boostedBet:boolean
}

export interface NineToFiveGameData extends NineToFiveData {
    evaluatedArea:string[][];
    betWayWins:BetWayWin[];
    totalSpinWinnings:number;
    playedBetValue:number;
    freespinsTriggeredThisSpin:boolean;
    freeSpinsPlayed:number;
    accumulatedFSWin:number;
}

export interface BetWayWin {
    amount:number;
    length:number;
    mode:string;
    multipliedAmount:number;
    multiplier:number;
    numberOfCombinations:number;
    symbol:string;
}

export interface WinLineData {
    betWayWin:BetWayWin,
    coordinates:StateMatrixCoordinate[],
    matrix:StateMatrix<boolean>
}

export interface WinData {
    lines:WinLineData[],
    matrix:StateMatrix<NineToFiveSymbolStates>
    winWays:number;
    winRatio:number;
    //accumulatedWinRatio:number;
    accumulatedWin:number;
    nonFreespinsMultipliedWin:number;
}
